export function getRouteCanonicalFromHash(hash: string) {
  const parts = hash.slice(1).split("/");
  const index = parts.indexOf("r");
  if (index >= 0 && parts[index + 1] !== undefined) {
    return decodeURI(parts[index + 1]);
  } else {
    return undefined;
  }
}
